import { render, staticRenderFns } from "./purchaseCheckHistory.vue?vue&type=template&id=f9be5986&scoped=true"
import script from "./purchaseCheckHistory.vue?vue&type=script&lang=js"
export * from "./purchaseCheckHistory.vue?vue&type=script&lang=js"
import style0 from "./purchaseCheckHistory.vue?vue&type=style&index=0&id=f9be5986&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9be5986",
  null
  
)

export default component.exports